module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-580.b28af62.woff2";